import axios from "axios";
import * as Constants from "../utils/constants";

export const getAllDatasets = async () => {
  try {
    const response = await axios.get(Constants.ALL_DATASETS, Constants.CONFIG);
    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const getDataset = async (id, page = 0, size = 60000) => {
  try {
    const response = await axios.get(
      `${Constants.ALL_DATASETS}/${id}?page=${page}&size=${size}`,
      Constants.CONFIG
    );
    return response.data;
  } catch (error) {
    return error.message;
  }
};
